<template>
  <div>
    <div class="bg-white shadow-sm rounded-md h-60 lg:mx-0 mx-3">
      <div class="border-b-0.5">
        <p class="p-2 text-sm">Upcoming Events</p>
      </div>
      <div
        class="flex justify-evenly items-center w-full p-5 relative overflow-x-auto"
        v-if="!loading"
      >
        <img
          class="absolute h-5 object-contain left-2 cursor-pointer transform rotate-90"
          src="@/assets/icons/caret.png"
        />

        <div v-if="filteredWeekDays.length" class="flex gap-2">
          <div
            :class="day.day == today ? 'bg-gray-200' : 'bg-white'"
            class="hover:bg-gray-200 cursor-pointer p-2 border-0.5 rounded"
            v-for="day in filteredWeekDays"
            :key="day.day + day.dayOfWeek"
          >
            <div class="flex flex-col items-center">
              <p class="text-sm">{{ day.dayOfWeek }}</p>
              <p class="font-bold text-2xl">{{ day.day }}</p>
            </div>
            <div class="text-xs text-center">
              <!-- Check if there are multiple events for the current day -->
              <template v-if="getEventsForDay(day.day).length > 1">
                <!-- Display one event in the card -->
                <div>
                  <p>{{ getEventsForDay(day.day)[0].Title }}</p>
                  <p>
                    {{ formatTime(getEventsForDay(day.day)[0].StartDateTime) }}
                    -
                    {{ formatTime(getEventsForDay(day.day)[0].EndDateTime) }}
                  </p>
                </div>
                <!-- Display a badge indicating the number of additional events -->

                <!-- Popover to display the list of events -->
                <el-popover trigger="click" placement="top">
                  <el-table :data="getEventsForDay(day.day)">
                    <el-table-column
                      label="Event"
                      prop="Title"
                    ></el-table-column>
                    <el-table-column label="From" prop="StartDateTime">
                      <template slot-scope="scope">
                        {{ formatTime(scope.row.StartDateTime) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="To" prop="EndDateTime">
                      <template slot-scope="scope">
                        {{ formatTime(scope.row.EndDateTime) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Venue" prop="Location">
                      <template slot-scope="scope">
                        {{ scope.row.Location }}
                      </template>
                    </el-table-column>
                    <el-table-column label="Overview" prop="Description">
                      <template slot-scope="scope">
                        {{ scope.row.Description }}
                      </template>
                    </el-table-column>
                    <!-- Add more columns for additional event details as needed -->
                  </el-table>
                  <el-button
                    slot="reference"
                    type="warning"
                    style="
                      padding: 0.1rem !important;
                      font-size: 0.1rem !important;
                    "
                  >
                    +{{ getEventsForDay(day.day).length - 1 }} more</el-button
                  >
                </el-popover>
              </template>
              <!-- If there's only one event, display it directly -->
              <template v-else>
                <div>
                  <p>{{ getEventsForDay(day.day)[0].Title }}</p>
                  <p>
                    {{ formatTime(getEventsForDay(day.day)[0].StartDateTime) }}
                    -
                    {{ formatTime(getEventsForDay(day.day)[0].EndDateTime) }}
                  </p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div v-else class="flex flex-col justify-center items-center">
          <p>No events for this week</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchDataMixin } from "@/mixins/fetchDataMixin";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "UpcomingEvents",
  mixins: [fetchDataMixin],

  data() {
    return {
      today: new Date().toDateString().split(" ")[2],
      days: [],
      upcomingEvents: [],
      popovers: {}, // Store popover visibility state for each day
    };
  },
  created() {
    this.getOrganizations();
    this.getEvents(); // Load upcoming events
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    currentWeekDays() {
      const today = new Date();
      const currentDay = today.getDay();
      let days = [];
      for (let i = 0; i < 7; i++) {
        const day = new Date(today);
        day.setDate(today.getDate() - currentDay + i);
        days.push({
          dayOfWeek: day.toDateString().split(" ")[0],
          day: day.toDateString().split(" ")[2],
        });
      }
      return days;
    },

    // Filter currentWeekDays to include only days with events
    filteredWeekDays() {
      return this.currentWeekDays.filter((day) =>
        this.hasEventsForDay(day.day)
      );
    },
  },

  methods: {
    showPopover(day) {
      // Toggle the visibility of the popover for the specified day
      this.popovers[day] = !this.popovers[day];
    },
    hasEventsForDay(day) {
      // Check if there are events for the given day
      return this.upcomingEvents.some((event) => {
        const eventDay = new Date(event.StartDateTime).getDate();
        return eventDay == day;
      });
    },

    // /{organization}/employee/all/v1/request
    getOrganizations() {
      const url = `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      url, options;
    },

    // /{organization}/event/upcomming/v1/request
    // https://api.talantahrm.com/dataposit/event/upcomming/v1/request
    getEvents() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/event/upcomming/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.upcomingEvents = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getEventsForDay(day) {
      // Filter upcoming events for the current day
      return this.upcomingEvents.filter((event) => {
        const eventDay = new Date(event.StartDateTime).getDate();
        return eventDay == day;
      });
    },

    formatTime(dateTime) {
      // Format date and time nicely
      const options = { hour: "2-digit", minute: "2-digit" };
      return new Date(dateTime).toLocaleTimeString(undefined, options);
    },
  },
};
</script>
